import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { VixellPalletsShowResponseComponent } from '../../../types/typescript-axios'
import { TabContainer } from '../../../components/part/tab-container'
import { NoPaddingLayoutWithTitle } from '../../../components/templates/no-padding-layout-with-title'
import { Lang } from '../../../translations/lang'
import { webRequest } from '../../../types/handle-api'
import { ReusableOrderHistory } from '../../../components/templates/transactions/reusable-order-history'
import { BelongingLogHistory } from '../../../components/templates/transactions/belonging-log-history'
import { ShippingStateLogHistory } from '../../../components/templates/transactions/shipping-state-log-history'
import { ProductNoteHistory } from '../../../components/templates/transactions/product-note-history'
import { VixellPalletVixellList } from '../../../components/templates/admin-vixell-pallets/admin-vixell-pallets-vixell-list'
import { QRCodeSVG } from 'qrcode.react'

export const AdminVixellPalletDetail = () => {
  const { id } = useParams<{ id: string }>()
  const [pallet, setPallet] = useState<VixellPalletsShowResponseComponent>()

  useEffect(() => {
    async function fetchData() {
      console.log('id')
      console.log(id)
      const response = await webRequest('VixellPalletsShow', {
        id: Number(id),
      })
      if (response.status === 200) {
        setPallet(response.data)
      }
    }

    fetchData()
  }, [id])

  return (
    <NoPaddingLayoutWithTitle
      title={Lang.admin.vixellPalletDetail.title}
      link={{
        label: Lang.admin.vixellPalletDetail.goBackToVixellPallets,
        link: '/vixell-pallets',
      }}
    >
      <div className="flex gap-[32px] container mt-16 mb-40">
        <div>
          <label>{Lang.admin.vixellPallets.serialNo}</label>
          <p className="mt-12 text-lg font-bold">{pallet?.pallet?.serialNo}</p>
        </div>
        <div>
          <label>{Lang.model}</label>
          <p className="mt-12 text-lg font-bold">{pallet?.pallet?.model}</p>
        </div>

        {pallet?.pallet?.serialNo && (
          <QRCodeSVG
            value={`${pallet?.pallet?.model}_${pallet?.pallet?.serialNo}`}
            size={90}
          />
        )}
      </div>

      {pallet && (
        <div className="container">
          <div className="w-200 pb-42">
            <VixellPalletVixellList vixells={pallet.pallet?.vixells} />
          </div>
        </div>
      )}

      <TabContainer
        tabs={[
          {
            tabName: Lang.tradeHistory,
            element: <ShippingStateLogHistory productType="VIXELL_PALLET" />,
          },
          {
            tabName: Lang.transitionHistory,
            element: <BelongingLogHistory productType="VIXELL_PALLET" />,
          },
          {
            tabName: Lang.reusableOrderHistory,
            element: <ReusableOrderHistory productType="VIXELL_PALLET" />,
          },
          {
            tabName: Lang.notesHistory,
            element: <ProductNoteHistory productType="VIXELL_PALLET" />,
          },
        ]}
      />
    </NoPaddingLayoutWithTitle>
  )
}
